var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66023 0L0 5V15L8.66023 20L17.3205 15V5L8.66023 0ZM8.66023 1.3782L11.4984 3.01684L4.62852 6.98313L1.79039 5.34449L8.66023 1.3782ZM8.06344 18.2772L1.19359 14.3109V6.37824L8.06344 10.3445V18.2772ZM5.82211 7.67223L12.692 3.7059L15.5301 5.34453L8.66023 9.31086L5.82211 7.67223ZM16.1269 14.3109L9.25703 18.2772V10.3445L16.1269 6.3782V14.3109H16.1269Z",
    fill: "#677489"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.69387405ca4289fd8d4a253561c08136.svg";
export { ForwardRef as ReactComponent };